import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ImportSuccessDialog = ({ open, onClose, successData }) => {
    if (!successData) return null;

    const { message, errors = [], warnings = [] } = successData;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Forecast import result</DialogTitle>
            <DialogContent>
                <Typography variant="body1" paragraph>
                    {message}
                </Typography>
                {errors.length > 0 && (
                    <Accordion defaultExpanded sx={{ mt: 1 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="subtitle2">Errors ({errors.length})</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
                                {errors.map((error, index) => (
                                    <ListItem key={index}>
                                        <ListItemText primary={error} primaryTypographyProps={{ variant: 'body2' }} />
                                    </ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                )}
                {warnings.length > 0 && (
                    <Accordion defaultExpanded={errors.length === 0} sx={{ mt: errors.length > 0 ? 1 : 1 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="subtitle2">Warnings ({warnings.length})</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
                                {warnings.map((warning, index) => (
                                    <ListItem key={index}>
                                        <ListItemText primary={warning} primaryTypographyProps={{ variant: 'body2' }} />
                                    </ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

ImportSuccessDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    successData: PropTypes.shape({
        message: PropTypes.string,
        updatedCount: PropTypes.number,
        skippedCount: PropTypes.number,
        errors: PropTypes.arrayOf(PropTypes.string),
        warnings: PropTypes.arrayOf(PropTypes.string),
    }),
};

export default ImportSuccessDialog;
